import React, { useState } from 'react';
import { Select } from 'tt-ui-lib/core';
import { PostIcon, ArticleIcon } from 'tt-ui-lib/icons';
import styles from './NewPost.module.scss';
import { NewPostModal } from '../../components/Modals/NewPostModal';

export const NewPost = ({ user, onClose }) => {
  const [createType, setCreateType] = useState('post');
  const [isModal, setModal] = useState(false);

  const onCloseModal = () => {
    setModal(false);
    if (onClose) {
      onClose();
    }
  };

  const createPostItems = [
    {
      value: 'post',
      label: (
        <div className={styles.selectItem}>
          <PostIcon style={{ width: 24, height: 24 }} />
          <span>Post</span>
        </div>
      ),
    },
    {
      value: 'article',
      label: (
        <div className={styles.selectItem}>
          <ArticleIcon style={{ width: 24, height: 24 }} />
          <span>Article</span>
        </div>
      ),
    },
    // {
    //   value: 'news',
    //   name: (
    //     <div className={styles.selectItem}>
    //       <NewsIcon style={{ width: 24, height: 24 }} />
    //       <span>News</span>
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className={styles.container} style={{ flexDirection: 'column' }}>
      <div className={styles.newPostBtn} onClick={() => setModal(true)}>{`Create ${
        createType === 'article' ? 'an article' : `a ${createType}`
      }`}</div>
      <div className={styles.inputOptions}>
        <Select
          className={styles.select}
          value={createType}
          onChange={(value) => {
            setCreateType(value);
          }}
          options={createPostItems}
        />
      </div>
      <NewPostModal visible={isModal} onClose={onCloseModal} createType={createType} user={user} />
    </div>
  );
};
